/* import __COLOCATED_TEMPLATE__ from './reinstall-modal.hbs'; */
/* RESPONSIBLE TEAM: team-data-foundations */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file: 🚀 */
/* eslint-disable ember/no-classic-classes */
/* eslint-disable ember/no-classic-components */
/* eslint-disable @intercom/intercom/require-empty-tagname */
import Component from '@ember/component';
import { action, computed } from '@ember/object';
import { readOnly } from '@ember/object/computed';
import { inject as service } from '@ember/service';

export default Component.extend({
  intl: service(),
  isReinstalling: false,
  reinstallConfirmValue: '',
  confirmWord: computed('intl.locale', function () {
    return this.intl.t('appstore.app-package.reinstall-modal.reinstall').toLocaleUpperCase();
  }),
  canReinstall: computed('confirmWord', 'reinstallConfirmValue', function () {
    return this.confirmWord === this.reinstallConfirmValue;
  }),
  isProtectedAppPackage: readOnly('appPackage.isProtectedAppPackage'),

  confirm: action(function () {
    this.set('isReinstalling', true);
    return this.reinstall.perform();
  }),
});
